import React from 'react';
import type { KindlyTriggerProps as Props } from './kindly-trigger.types';
import { useKindlyChat } from './use-kindly-bot';

const KindlyTrigger: React.FC<Props> = ({ botKey, language = 'en' }) => {
  useKindlyChat(botKey, language);
  return null;
};

export default KindlyTrigger;
